/**
 * JOAteliersGate — Temporarily redirects all public `/ateliers*` routes
 * to the home page while the workshops feature is hidden from the website.
 *
 * Admin pages remain accessible (the admin sidebar link is removed
 * separately via JOAdminSidebarInjector, but `/admin/ateliers` is still
 * reachable by direct URL for draft management).
 *
 * Renderless — runs in useEffect on each navigation.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function JOAteliersGate() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname || "";
    // Public ateliers routes — NOT admin/ateliers
    if (path === "/ateliers" || path.startsWith("/ateliers/")) {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
